<div class="lvi-content">
	<div class="avatar">
		<!-- Drapeau pour pays/ville -->
		<span *ngIf="hasDrapeau()" class="flag-icon flag-icon-squared"
			  [ngClass]="'flag-icon-' + data.fraisMissionRegion?.codeIso?.toLowerCase()"></span>
		<!-- Icône globe pour zone/territoire -->
		<mat-icon *ngIf="!hasDrapeau()">language</mat-icon>
	</div>
	<div class="lvi-body">
		<div class="title">
			<a class="label" (click)="onEdit()">{{ data?.dateApplication | date:'shortDate' }}</a>
		</div>
		<ul class="lvi-attrs">
			<li *ngFor="let indemnite of data?.listeFraisMissionIndemnite">
				<strong>{{ indemnite.libelleDomaine }}</strong>
				{{ indemnite.montant | number:'1.2-2' }} {{ data?.devise }}
			</li>
		</ul>
	</div>
	<div class="lvi-actions">
		<button mat-icon-button (click)="onEdit()" [matTooltip]="'global.actions.modifier' | translate">
			<i class="nio icon-edition"></i>
		</button>
		<button mat-icon-button (click)="onDelete()" [matTooltip]="'global.actions.supprimer' | translate">
			<i class="nio icon-suppression"></i>
		</button>
	</div>
</div>